<script>
  import { PRODUCT_CATEGORY } from "@src/config/fake-data";

  import BrandLayout from '../components/Layout'
  import ListProduct from "@components/List/Product";
  import MobileBrandPageTitle from "@components/List/MobileBrandPageTitle";
  import { dataStatusOptions } from "@utils/zerone-options";
  import { getDefaultDataStatusOptions } from "@utils/zerone-get-default";
  import setWindowHistory from "@utils/window-history";
  import { optionComputed,brandComputed  } from '@store/helpers'

  export default {
    page() {
      return {
        title: `${this.currentBrand.title}`,
      }
    }, 
    components: {
      BrandLayout,
      ListProduct,
      MobileBrandPageTitle
    },
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        },
      },
      pagination: {
        type: Object,
        default: () => {
          return {}
        },
      }
    },
    data() {
      return {
        filterCategoryList: PRODUCT_CATEGORY,
        filterCategory: this.$route.query.filterCategory
          ? this.$route.query.filterCategory.split(',')
          : [],
        query: this.$route.query.query || '', 
        littleCategoryList: [],
        dataOderBy: getDefaultDataStatusOptions(this.$route.query.orderBy) || '' ,
        dataOderByList: dataStatusOptions(),
        filterLoading: false,
        isfilterdone: false,
        isShowFilterMenu: false,
        filterType: 'click',
        productList: this.list || [],
        productPagination: this.pagination || {},
      }
    },
    computed: {
      ...optionComputed,
      ...brandComputed,
      hasFilter() {
        if(Object.keys(this.$route.query).length) {
          return Object.keys(this.$route.query)
            .some((key) => {
              return this.$route.query[key] !== undefined
            })
        } else {
          return false
        }
      },
      formattedList() {
        return this.productList.map((item) => ({
          title: item.title,
          brands: item.brands,
          categoryTitle: item.categoryTitle,
          to: {
            name: 'brand-product-item',
            params: {
              productAlias: item.alias,
              brandAlias: item.brands[0].alias
            }
          },
        }))
      },
      buttonBarList() {
        return [
          {
            text: '確定',
            class: 'flex-grow-1',
            buttonClass: 'isStylePrimary isRadius isSmall isFull',
            onClick: () => {
              this.changeFilter()
            },
          },
          {
            text: '取消',
            class: 'flex-grow-1',
            buttonClass: 'isStyleDark isOutline2 isRadius isSmall isFull',
            onClick: () => {
              this.isShowFilterMenu = false
            },
          },
        ]
      },
      filterList() {
        return [
          {
            text: '產品類別',
            alias: 'filterCategory',
            list: this.filterCategoryList,
            selectData: this.filterCategory,
            buttonClass: 'isStylePrimary isOutline2 isDelete'
          },
        ]
      }
    },
    created() {
      this.fetchFilters();
      this.filterLittleCategoryList();
    },
    mounted() {
      // if(this.$route.query.page) {
      //   this.$scrollToElement({
      //     $el: this.$refs['sectionList'].$el,
      //     offset: 290,
      //   });
      // }
      const initResizeListener = () => {
        window.addEventListener('resize', this.setFilterType)
      };

      this.setFilterType();
      initResizeListener();
    },
    destroyed() {
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.setFilterType)
      };

      removeResizeListener();
    },
    methods: {
      async fetchFilters() {
        this.filterLoading = true;
        const { product_parent_category } = await this.$store.dispatch('category/fetchCategroy', {
          types: ['product_parent_category'],
          brand_alias: this.$route.params.brandAlias,
        })
        this.filterCategoryList = product_parent_category || this.productCategory,
        this.filterLoading = false;
      },
      filterLittleCategoryList() {
        const data = []
        this.list.filter((item) => {
          if(data.indexOf(item.categoryTitle) === -1) {
            data.push(item.categoryTitle)
          }
        })
        this.littleCategoryList = data.map((item) => {
          return {
            text: item,
            showMoreButton: false
          }
        });
      },
      // onSearch(value) {
      //   this.$router.push({
      //     name: this.$route.name,
      //     params: this.$route.params,
      //     query: {
      //       ...this.$route.query,
      //       filterCategory: this.filterCategory.length > 0
      //         ? this.filterCategory.join(',')
      //         : undefined,
      //       query: this.query || undefined,
      //       orderBy: this.dataOderBy || undefined
      //     }
      //   })
      // },
      onChangePagination(page) {
        this.tryToFetchProductList({
          storeParams: {
            // ...this.$route.params,
            page
          }
        }).then(() => {
            const url = new URL(window.location)
            let params = url.searchParams;
            if(params.has('page')) {
              this.$scrollToElement({
                $el: this.$refs['sectionList'].$el,
                offset: 200,
              });
            }
        })
      },
      async tryToFetchProductList({ storeParams } = {}) {
        this.filterLoading = true;
        const params = {
          product_category_alias: this.filterCategory.length
            ? this.filterCategory
            : undefined,
          search: this.query || undefined,
          limit: 10,
          ...this.statusMap() ?? undefined,
          ...storeParams,
          brand_alias: [this.$route.params.brandAlias],
        }
        await this.$store.dispatch('product/fetchList', params)
          .then(({ items,pagination }) => {
            const setData = () => {
              this.productList = items;
              this.productPagination = pagination;
              // this.featuredList = featured
            };

            setData();
            
          })
          .finally(() => {
            this.filterLoading = false;
          })
      },
      onClearSearch() {
        this.filterCategory = [];
        this.filterBrand = [];
        const query = () => {
          const query = {
            ...this.$route.query,
            query: this.query = undefined,
            filterCategory: undefined,
            filterBrand: undefined,
            page: undefined,
            orderBy: this.dataOderBy = undefined,
          }
          return  query
        }
        setWindowHistory({
          query: {
            ...query(),
            // page: 1
          }
        });
        this.tryToFetchProductList({
          storeParams: {
            page: 1,
            order: undefined,
            orderBy: undefined
          }
        });
      },
      filterCategoryTitle(singleAlias, filterList) {
        const result = () => filterList.find((item) => {
          return item.alias === singleAlias
        })
        if(result()) {
          this.isfilterdone = true
          return result().title
        }
        this.isfilterdone = true
        return false
      },
      deleteFilterCategory(item, filterCategory) {
        filterCategory.splice(item, 1)
        if(this.filterType === 'prompt') {
          this.changeFilter()
        }
      },
      changeFilter(val) {
        const query = () => {
          const query = {
            filterCategory: this.filterCategory.length > 0
              ? this.filterCategory.join(',')
              : undefined,
            query: this.query ?? undefined,
          }
          return query;
        };
        setWindowHistory({
          query: {
            ...this.$route.query,
            page: 1,
            ...query()
          }
        });
        this.tryToFetchProductList({

          storeParams: {
            // ...this.$route.params,
            page: 1
          }
        }).then(()=> {
          if(this.filterType === 'click') {
            this.isShowFilterMenu = false
          }
        })
      },
      goToFilter() {
        // this.$router.push({
        //   name: this.$route.name,
        //   params: this.$route.params,
        //   query: {
        //     ...this.$route.query,
        //     filterCategory: this.filterCategory.length > 0
        //       ? this.filterCategory.join(',')
        //       : undefined,
        //     query: this.$route.query.query || undefined,
        //     page: undefined
        //   }
        // })
      },
      onShowFilterMenu(status) {
        this.isShowFilterMenu = status
      },
      setFilterType() {
        this.filterType = document.body.clientWidth > 767
          ? 'prompt'
          : 'click';
      },
      onChangeOrderBy() {
        setWindowHistory({
          query: {
            orderBy: this.dataOderBy,
            page:1
          }
        });
        this.tryToFetchProductList({
          storeParams: {
            ...this.statusMap()
          }
        });
      },
      statusMap() {
        const statusMap =  [
          {
            alias: 'newest',
            query: {
              orderBy: 'created_at',
              order: 'desc' 
            }
          },
          {
            alias: 'oldest',
            query: {
              orderBy: 'created_at',
              order: 'asc' 
            }
          },
          {
            alias: 'asc',
            query: {
              orderBy: 'title',
              order: 'asc' 
            },
          },
          {
            alias: 'desc',
            query: {
              orderBy: 'title',
              order: 'desc' 
            }
          }
        ]
        const currentStatus = statusMap.filter((item) => {
          return item.alias === this.dataOderBy
        })
        return currentStatus[0]?.query ?? {}
      }
    }
  }
</script>
<template>
  <BrandLayout>
    <section :class="$style.sectionProductList" class="section ">
      <div v-loading="filterLoading" class="container">
        <BaseSectionTitle
          title="產品系列"
          class="text-center d-md-block d-none"
        />
        <MobileBrandPageTitle
          title="產品系列"
          class="d-md-none mt-md-4 mt-5"
          @openFilter="onShowFilterMenu(!isShowFilterMenu)"
        />
        <template v-if="hasFilter || list.length">
          <div class="row">
            <div class="col-lg-4 col-xl-3 mb-5 mb-xl-0">
              <BaseFilterBox
                :is-show-filter="isShowFilterMenu" 
                @showFilterMenu="onShowFilterMenu"
              >
                <div class="mb-4 d-md-none">
                  <div class="text-base mb-4">已篩選條件</div>
                  <div class="row mobileGutter">
                    <template v-for="(filter, $index) in filterList">
                      <template v-if="filter.list.length && filter.selectData.length">
                        <div   
                          v-for="(item,$index2) in filter.selectData"
                          :key="item"
                          class="col-6"
                        >
                          <BaseButton
                            :class="filter.buttonClass"
                            class="isFull isRadius isEllipsis"
                            @click="deleteFilterCategory($index2,filter.selectData)"
                          >
                            {{ filterCategoryTitle(item, filter.list) }}
                            <i class="fal fa-times icon"></i>
                          </BaseButton>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
                <BaseSearch
                  v-model="query"
                  title="搜尋"
                  title-class="d-none d-lg-block"
                  @search="changeFilter"
                />
                <BaseOrderBy
                  v-model="dataOderBy"
                  title="排序"
                  :type="filterType"
                  class="isStyleBase w-100 mb-lg-5 mb-3"
                  :list="dataOderByList"
                  @changeOrderBy="onChangeOrderBy"
                />
                <el-scrollbar class="isStyleFilter">
                  <BaseFilter
                    v-model="filterCategory"
                    title="產品類別"
                    title-class="d-flex d-md-none d-lg-flex"
                    :list="filterCategoryList"
                    :type="filterType"
                    is-show
                    @changeFilter="changeFilter"
                  />
                  <BaseButtonBar
                    :button-list="buttonBarList"
                    is-show
                    class="d-md-none"
                  />
                </el-scrollbar>
              </BaseFilterBox>
            </div>
            <div class="col-lg-8 col-xl-9">
              <div class="d-lg-flex flex-wrap mb-4 d-none">
                <template v-for="(filter, $index) in filterList">
                  <template v-if="filter.list.length && filter.selectData.length">
                    <div   
                      v-for="(item,$index2) in filter.selectData"
                      :key="item"
                      class="mr-2"
                    >
                      <BaseButton
                        :class="filter.buttonClass"
                        @click="deleteFilterCategory($index2,filter.selectData)"
                      >
                        {{ filterCategoryTitle(item, filter.list) }}
                        <i class="fal fa-times icon"></i>
                      </BaseButton>
                    </div>
                  </template>
                </template>
              </div>
              <template v-if="productList.length">
                <ListProduct
                  ref="sectionList"
                  type="grid"
                  :list="formattedList"
                  :pagination="productPagination"
                  @change-page="onChangePagination"
                />
              </template>
              <BaseNull 
                v-else 
                is-search-null
                @clearSearch="onClearSearch"
              />
            </div>
          </div>
        </template>
        <BaseNull
          v-else
          content="<p class='my-0'>目前此頁面無資料</p> <p class='mb-0 mt-3'>點擊下方按鈕，探索更多資訊</p>"
        >
          <BaseButton
            :to="{
              name: 'brand-item',
              params: {
                brandAlias: $route.params.brandAlias,
              },
            }"
            class="isStylePrimary isCol4 isRadius mt-5">
            探索更多資訊
          </BaseButton>
        </BaseNull>
      </div>
    </section>
  </BrandLayout>
</template>
<style lang="scss" module>
  .sectionProductList {
    :global {
      .sectionProductList {
        &__filterBox {
          max-height: 37rem;
          padding-right: 19px;
          margin-right: -19px;
          overflow-y: overlay;
          @include max-md {
            height: auto;
            overflow: auto;
            margin: 0;
            padding: 0;
          }
        }
      }
    }
  }
</style>
